import React, { useState, useEffect } from 'react';
import './App.css';
import UploaderComponent from './components/UploaderComponent';
import VideoManagement from './components/VideoManagement';
import LoginPage from './components/LoginPage';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState('upload');

  useEffect(() => {
    const token = localStorage.getItem('ufilm_token');
    const savedUser = localStorage.getItem('ufilm_user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('ufilm_token');
    localStorage.removeItem('ufilm_user');
    setUser(null);
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <h2 style={{ color: 'white' }}>Loading...</h2>
      </div>
    );
  }

  if (!user) {
    return <LoginPage onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div>
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '16px 40px',
        color: 'white',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '30px' }}>
          <span style={{ fontSize: '20px', fontWeight: 'bold' }}>🎬 UFILM</span>
          <div style={{ display: 'flex', gap: '16px' }}>
            <button
              onClick={() => setCurrentPage('upload')}
              style={{
                background: currentPage === 'upload' ? 'rgba(255,255,255,0.3)' : 'transparent',
                border: '1px solid rgba(255,255,255,0.5)',
                color: 'white',
                padding: '8px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              📤 Upload
            </button>
            <button
              onClick={() => setCurrentPage('manage')}
              style={{
                background: currentPage === 'manage' ? 'rgba(255,255,255,0.3)' : 'transparent',
                border: '1px solid rgba(255,255,255,0.5)',
                color: 'white',
                padding: '8px 20px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '600'
              }}
            >
              📹 My Videos
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <span style={{ opacity: 0.9 }}>Welcome, {user.name}!</span>
          <button
            onClick={handleLogout}
            style={{
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid white',
              color: 'white',
              padding: '8px 20px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '600'
            }}
          >
            Logout
          </button>
        </div>
      </div>

      {currentPage === 'upload' ? <UploaderComponent /> : <VideoManagement />}
    </div>
  );
}

export default App;
